import type { TextareaProps } from './Textarea';

export interface OldTextareaProps extends Omit<TextareaProps, 'status' | 'hasCounter'> {
  /** @deprecated status='error'를 대신 사용해주세요. */
  error?: boolean;
  /** @deprecated hasCounter를 대신 사용해주세요. */
  showCounter?: boolean;
}

export function convertOldTextareaProps(props: OldTextareaProps): TextareaProps {
  const { error, showCounter, ...restProps } = props;

  return {
    ...restProps,
    status: error ? 'error' : undefined,
    hasCounter: showCounter,
  };
}
